//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListSkeleton from "../../components/Skeletons/ListSkeleton.vue";
import ActividadesAPI from '@/api/promotores/actividades.api'
import groupBy from 'lodash/groupBy'
import moment from "moment"

export default {
	components: { ListSkeleton },
	data() {
		return {
			actividades: [],
			page: 0,
			pages: 0,
			loading: false,
		}
	},
	filters: {
     clearText: function(data){
		const left = "{";
		const right   = "}";
            const limpiarString = data.split(left).join("").split(right).join("").split(/[""]/).join(" ")
			.split(/[[]]/).join("")
			return limpiarString;
        },
	},
	computed: {
		grupos() {
			return groupBy(this.actividades, (actividad) => moment(actividad.created_at).format('YYYY-MM-DD'))
		}
	},

	mounted() {
		this.loadActividades()
	},

	methods: {
		async loadActividades(page = 1) {
			try {
				this.loading = true
				const { data, current_page, last_page } = await ActividadesAPI.all({ page })		
				this.page = current_page
        this.pages = last_page

        this.actividades = data
				
			} finally {
				this.loading = false
			}
		}
	}
}
